module.exports = __webpack_public_path__ + "media/images/user/favicons/icon-128x128-ddb9f4ea9dae78da3d6a11e92e34232e.png";